import { render } from "./LanguageManagement.vue?vue&type=template&id=41f40536&scoped=true"
import script from "./LanguageManagement.vue?vue&type=script&lang=js"
export * from "./LanguageManagement.vue?vue&type=script&lang=js"

import "./LanguageManagement.vue?vue&type=style&index=0&id=41f40536&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f40536"],['__file',"src/components/shared/LanguageManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41f40536"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41f40536', __exports__)) {
    api.reload('41f40536', __exports__)
  }
  
  module.hot.accept("./LanguageManagement.vue?vue&type=template&id=41f40536&scoped=true", () => {
    api.rerender('41f40536', render)
  })

}


export default __exports__